export const cloudinary = {
    parameters: {
        clientId: 'b3d2fa7b-4d7f-4058-aab6-51ea64b1f803',
        organizationId: 'f_ecom_bbxl_006',
        shortCode: 'effx50gb',
        siteId: 'Cavenders',
        host: '3000',
        contentAssetId: 'home-main'
    },
    versions: {
        CLDVideoPlayerVersion: '1.10.1',
        CLDCoreShrinkwrapJSURLVersion: '2.13.0'
    },
    CLD_TRACKING_PARAM: '?_i=AP3',
    CLD_PGW_TRACKING_PARAM: 'AP3'
}


export const updateTrackingParam = (srcset) => {
    const splits = srcset.split(' ')
    const newSrcset = splits.map((split) => {
        if (split.lastIndexOf('?') > -1) {
            return split.substring(0, split.lastIndexOf('?')) + cloudinary.CLD_TRACKING_PARAM
        } else {
            return split
        }
    })

    return newSrcset.join(' ')
}